<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card pt-5 pb-5">
        @if (isConfiguredQR) {
          <div class="card-body pb-0">
            <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
               routerLink="/inout-qr">
              <div class="d-flex" style="gap:1rem;">
                <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">qr_code</span></i>
                <b class="align-content-center" style="min-width:7rem">&nbsp;入退館QR</b>
              </div>
            </a>
          </div>
        }
        <div class="card-body pb-0">
          <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
             routerLink="/member">
            <div class="d-flex" style="gap:1rem;">
              <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">person</span></i>
              <b class="align-content-center" style="min-width:7rem">&nbsp;会員情報</b>
            </div>
          </a>
        </div>
        <div class="card-body pb-0">
          <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
             routerLink="/transaction">
            <div class="d-flex" style="gap:1rem;">
              <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">currency_yen</span></i>
              <b class="align-content-center" style="min-width:7rem">&nbsp;支払情報</b>
            </div>
          </a>
        </div>
        <div class="card-body pb-0">
          <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
             routerLink="/inout">
            <div class="d-flex" style="gap:1rem;">
              <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">footprint</span></i>
              <b class="align-content-center" style="min-width:7rem">&nbsp;入退館履歴</b>
            </div>
          </a>
        </div>
        <div class="card-body pb-0">
          <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
             routerLink="/notification">
            <div class="d-flex" style="gap:1rem;">
              <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">inventory</span></i>
              <b class="align-content-center" style="min-width:7rem">&nbsp;諸届</b>
            </div>
          </a>
        </div>
        @if (reservationGlobalFlag) {
          <div class="card-body pb-0">
            <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
               routerLink="/pt-reservation">
              <div class="d-flex" style="gap:1rem;">
                <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">calendar_month</span></i>
                <b class="align-content-center" style="min-width:7rem">&nbsp;PT予約</b>
              </div>
            </a>
          </div>
        }
        @if (isCounselable) {
          <div class="card-body">
            <a class="nav-link d-flex border border-primary rounded rounded-lg list-group-item-primary p-3 justify-content-md-center"
               routerLink="/personal">
              <div class="d-flex" style="gap:1rem;">
                <i class="text-primary"><span class="material-symbols-outlined align-bottom font-4xl">contract</span></i>
                <b class="align-content-center" style="min-width:7rem">&nbsp;パーソナルログ</b>
              </div>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
